import api, { unwrap } from './client'
import type { VoicePlan } from '@/types/models'

export const voicePlansApi = {
  async index(projectId: string): Promise<VoicePlan[]> {
    const { data } = await api.get<{ data: VoicePlan[] }>(`/projects/${projectId}/voice-plans`)
    return data.data ?? []
  },

  async upload(projectId: string, audio: Blob, filename: string, signal?: AbortSignal): Promise<VoicePlan> {
    const formData = new FormData()
    formData.append('audio', audio, filename)

    return unwrap(
      api.post<{ data: VoicePlan }>(`/projects/${projectId}/voice-plans`, formData, { signal }),
    )
  },

  show(projectId: string, voicePlanId: string): Promise<VoicePlan> {
    return unwrap(api.get<{ data: VoicePlan }>(`/projects/${projectId}/voice-plans/${voicePlanId}`))
  },

  approve(projectId: string, voicePlanId: string, queueForBuild: boolean): Promise<VoicePlan> {
    return unwrap(
      api.patch<{ data: VoicePlan }>(`/projects/${projectId}/voice-plans/${voicePlanId}`, {
        queue_for_build: queueForBuild,
      }),
    )
  },

  async discard(projectId: string, voicePlanId: string): Promise<void> {
    await api.delete(`/projects/${projectId}/voice-plans/${voicePlanId}`)
  },
}
